import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { merge, throwError as _throw } from 'rxjs';
import { switchMap, filter } from 'rxjs/operators';

import { DlgTransferComponent } from './dlg-transfer';

@Injectable()
export class ShowDlgTransferService {
    constructor(
        private _dialog: MatDialog,
    ) {
    }

    show(data): Promise<any> {
        const dialogRef = this._dialog.open(DlgTransferComponent, {
            panelClass: ['--ui'],
            data
        });

        const source = dialogRef.afterClosed();
        const success$ = source
            .pipe(filter<any>((val) => !!val));
        const error$ = source
            .pipe(filter<any>((val) => !val))
            .pipe(switchMap((error) => _throw(`${ error }`)));

        return merge(success$, error$).toPromise();
    }
}
